import React, { createContext, useState, useContext, useCallback } from 'react';

// Journal search state — kept separate from SearchContext (MKE) and
// CISearchContext (Collective Intelligence) so each view's search flow is
// independent. Intentionally lightweight: this context carries only the active
// query and the execute/clear actions. Unlike CISearchContext, it does NOT own
// the results or pagination — Journal.js keeps its own entry list and
// pagination (loadEntries) and simply reacts to query changes here. This
// preserves the Journal layout/pagination established previously.

export const JournalSearchContext = createContext(null);

export const useJournalSearch = () => {
  const context = useContext(JournalSearchContext);
  if (!context) {
    throw new Error('useJournalSearch must be used within a JournalSearchProvider');
  }
  return context;
};

export const JournalSearchProvider = ({ children }) => {
  const [query, setQuery] = useState('');

  // Set the active query (trimmed). Journal.js watches `query` and reloads
  // its entry list at page 1 whenever it changes.
  const executeSearch = useCallback((q) => {
    setQuery((q || '').trim());
  }, []);

  // Reset to the full, unfiltered list.
  const clearSearch = useCallback(() => {
    setQuery('');
  }, []);

  return (
    <JournalSearchContext.Provider value={{ query, executeSearch, clearSearch }}>
      {children}
    </JournalSearchContext.Provider>
  );
};
